import React from 'react';

const TitleWithLine = ({ title, style, color = '#337D96', lineColor = '#66C7D1' }) => {
  return (
    <div style={{...styles.container, ...style}}>
      <h2 style={{...styles.title, color: color,}}>{title}</h2>
      <div style={{...styles.line, borderBottom: `2px solid ${lineColor}`}} />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%', // Full width
    margin: '5px 0'
  },
  title: {
    margin: 0,
    fontSize:'18px',
    paddingRight: '10px', // Space between title and line
  },
  line: {
    flexGrow: 1, // Allows the line to take up remaining space
  },
};

export default TitleWithLine;